<button class="m-button"
        :class="{ 'm--is-skin-primary': isSkinPrimary,
               'm--is-skin-secondary': isSkinSecondary,
               'm--is-waiting': isWaiting,
               'm--is-disabled': disabled,
               'm--is-full-size': fullSize }"
        :disabled="disabled || isWaiting"
        :type="type"
        @click="onClick"
        @mousedown="onMousedown"
        @focus="onFocus"
        @blur="onBlur"
        @touchstart="onTouchstart"
        @touchend="onTouchend">
    <m-icon aria-hidden="true"
            class="m-button__icon m--is-left"
            :name="iconName"
            :size="iconSize"
            v-if="hasIconLeft"></m-icon>
    <m-spinner aria-hidden="true"
               class="m-button__icon m--is-left"
               skin="lighter"
               size="small"
               v-if="hasWaitingIconLeft"></m-spinner>
    <span class="m-button__text">
        <slot></slot>
        <span class="m-button__precision"
              v-if="hasPrecision">
            <slot name="precision"></slot><template v-if="precision"></template>{{precision}}
        </span>
    </span>
    <m-spinner aria-hidden="true"
               class="m-button__icon m--is-right"
               skin="lighter"
               size="small"
               v-if="hasWaitingIconRight"></m-spinner>
    <m-icon aria-hidden="true"
            class="m-button__icon m--is-right"
            :name="iconName"
            :size="iconSize"
            v-if="hasIconRight"></m-icon>
</button>
